import { Flex } from 'theme-ui';
import { Switch } from '@odekoteam/doppio';
import { GetLocation } from 'src/graphql/types/delivery';
import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { ModalType, showModal } from 'src/state/slices/modal';
import { useMetrobiAdmin } from './metrobi';
import { BulkEditTab } from '../Modal/BulkEditLocationsModal';

export default function MetrobiEligibility({
  location,
}: {
  location: GetLocation;
}): JSX.Element {
  const dispatch = useAppDispatch();
  const isAdmin = useMetrobiAdmin();
  const metrobi = useAppSelector((state) => state.locations.metrobi);
  const inherited = location.effectivelyExcluded && !location.locationExcluded;
  const pending = metrobi?.pendingIds.includes(location.id);
  const known =
    typeof location.effectivelyExcluded === 'boolean' &&
    typeof location.locationExcluded === 'boolean';
  return (
    <div>
      <Flex>
        <Switch
          id={`metrobi-eligibility-${location.id}`}
          accessibilityLabel={`Metrobi Eligible for ${location.businessName}`}
          isChecked={location.effectivelyExcluded === false}
          isDisabled={!isAdmin || !known || inherited || pending || !metrobi}
          onCheckedChange={(eligible): void => {
            dispatch(
              showModal({
                type: ModalType.BulkEditLocationsModal,
                dismissButtonLabel: 'Cancel',
                variables: {
                  locations: [location],
                  metrobiOnly: true,
                  cohorts: [],
                  initialTab: BulkEditTab.MetrobiEligibility,
                  metrobiEligible: eligible,
                  metrobiContextId: metrobi?.contextId,
                },
              }),
            );
          }}
        />
        <span sx={{ marginLeft: '12px', variant: 'text.paragraphLgDefault' }}>
          {pending
            ? 'Saving…'
            : !known
            ? 'Unavailable'
            : location.effectivelyExcluded
            ? 'Off'
            : 'On'}
        </span>
      </Flex>
      {inherited && (
        <div sx={{ variant: 'text.paragraphSmDefault' }}>
          Excluded by company
        </div>
      )}
      {!isAdmin && (
        <div sx={{ variant: 'text.paragraphSmDefault' }}>
          Admin access required to edit
        </div>
      )}
    </div>
  );
}
